// import React from "react";
// import {toAbsoluteUrl} from "../../../_metronic/_helpers";

// export function ErrorPage1() {
//   return (
//     <div className="d-flex flex-column flex-root">
//       <div
//         className="d-flex flex-row-fluid flex-column bgi-size-cover bgi-position-center bgi-no-repeat p-10 p-sm-30"
//         style={{
//           backgroundImage: `url(${toAbsoluteUrl("/media/error/bg1.jpg")})`
//         }}
//       >
//         <h1
//           className="font-size-sm-100 font-weight-boldest text-dark-75 mt-15"
//           style={{ fontSize: "150px" }}
//         >
//           404
//         </h1>
//         <p className="font-size-h3 font-weight-light">
//           OOPS! Something went wrong here
//         </p>
//       </div>
//     </div>
//   );
// }


import React from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {toAbsoluteUrl} from "../../../_metronic/_helpers";
import * as auth from "../Auth/_redux/authRedux"

function ErrorPage1(props) {
  const {SSO_URL} = window.ENV;
  // const wnd = window.open(`${SSO_URL}/logout`);
  const history = useHistory();

  setTimeout(() => {
    // props.logout()
    // window.open(`${SSO_URL}/logout`).close();
    history.push("/logout");
  },5000)
  return (
    <div className="d-flex flex-column flex-root">
      <div
        className="d-flex flex-row-fluid flex-column bgi-size-cover bgi-position-center bgi-no-repeat p-10 p-sm-30"
        style={{
          backgroundImage: `url(${toAbsoluteUrl("/media/bg/error/403.jpg")})`
        }}
      >
      </div>
    </div>
  );
}

// export default ErrorPage1
export default connect(null, auth.actions)(ErrorPage1)